import { DataSource, Label, Layout, } from "@mcleod/components";

export abstract class AutogenLayoutCallinScript extends Layout {
    labelTitle: Label;
    sourceCallin: DataSource;
    sourceCallinStop: DataSource;
    sourceDispatch: DataSource;
}
